<script setup>
import { useGlobeStore } from "@stores/globe";

const globeStore = useGlobeStore();
</script>

<template>
    <Transition name="fade" appear>
        <div
            v-if="!globeStore.selectedCountry"
            class="questions bg-marine-800 border-marine-500 hidden flex-col justify-center border-b px-6 py-4 lg:flex"
        >
            <p class="body-sm leading-[1.2] font-medium">
                Questions? Contact us at<br />
                <a
                    href="mailto:ishowspeed@expediagroup.com"
                    class="text-yellow-400 hover:underline"
                >
                    ishowspeed@expediagroup.com
                </a>
            </p>
        </div>
    </Transition>
</template>

<style scoped>
.questions {
    grid-column: -5 / -1;
    grid-row: -4 / -3;
    z-index: 3;
}
</style>
